import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {CdkTreeModule} from '@angular/cdk/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { DateAdapter, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTreeModule } from '@angular/material/tree';
// -------------------
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import { DatePipe } from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import { DateFormat } from "./date-format";
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {OverlayModule} from '@angular/cdk/overlay';
import { HomeComponent } from './home/home.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalpopService } from './modalpop.service';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { ReservationsDetailsComponent } from './reservations-details/reservations-details.component';
import { QualificationDetailsComponent } from './qualification-details/qualification-details.component';
import { AdditionalDetailsComponent } from './additional-details/additional-details.component';
import { PhotoSignatureDetailsComponent } from './photo-signature-details/photo-signature-details.component';
import { AdmissionDetailsComponent } from './admission-details/admission-details.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { StudentRegistrationTabComponent } from './student-registration-tab/student-registration-tab.component';
import { StudentSettingComponent } from './student-setting/student-setting.component';
import { StudentFormComponent } from './student-form/student-form.component';
import { AdminSettingComponent } from './admin-setting/admin-setting.component';
import { StudentRegisterComponent } from './student-register/student-register.component';
import { StudentSettingPageComponent } from './student-setting-page/student-setting-page.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { AlertboxComponent } from './alertbox/alertbox.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component';
import { ConformationModelComponent } from './conformation-model/conformation-model.component';
import { FeesComponent } from './fees/fees.component';
import { FeeProcessComponent } from './fee-process/fee-process.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ExamFormComponent } from './exam-form/exam-form.component';
import { ExamFeesComponent } from './exam-fees/exam-fees.component';
import { ExamFeeProcessComponent } from './exam-fee-process/exam-fee-process.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { HttpTokenInterceptorService } from './http-token-interceptor.service';
import { AdmitCardComponent } from './admit-card/admit-card.component';
import { ReportsComponent } from './reports/reports.component';
import { MarklistComponent } from './marklist/marklist.component';
import { OpenCollegeAddmissionComponent } from './open-college-addmission/open-college-addmission.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { DownloadDetailsComponent } from './download-details/download-details.component';
import { SubjectSelectionComponent } from './subject-selection/subject-selection.component';
import { ExamEligibilityComponent } from './exam-eligibility/exam-eligibility.component';
import { PrintMsgBoxComponent } from './print-msg-box/print-msg-box.component';
import { ComplaintFormComponent } from './complaint-form/complaint-form.component';
import { TCLCMCComponent } from './tc-lc-mc/tc-lc-mc.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { TclcFeesComponent } from './tclc-fees/tclc-fees.component';
import { TclcFeesProcessComponent } from './tclc-fees-process/tclc-fees-process.component';
import { GrievanceCommentComponent } from './grievance-comment/grievance-comment.component';
import { GrievanceCommentFormComponent } from './grievance-comment-form/grievance-comment-form.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CertificateComponent } from './certificate/certificate.component';
import { TranscriptFeesComponent } from './transcript-fees/transcript-fees.component';
import { TranscriptFeeProcessComponent } from './transcript-fee-process/transcript-fee-process.component';
import { TranscriptComponent } from './transcript/transcript.component';
import { EasebuzzPayComponent } from './easebuzz-pay/easebuzz-pay.component';
import { RazorpayPayComponent } from './razorpay-pay/razorpay-pay.component';
import { PayGatewayComponent } from './pay-gateway/pay-gateway.component';
import { PaymentMessageComponent } from './payment-message/payment-message.component';
import { ProvisionalComponent } from './provisional/provisional.component';
import { CertificateLoginComponent } from './certificate-login/certificate-login.component';
import {  MAT_DATE_FORMATS } from '@angular/material/core';
import {  MY_DATE_FORMATS } from './date-format';
import { PracticalTimeTableComponent } from './practical-time-table/practical-time-table.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    PersonalDetailsComponent,
    ContactDetailsComponent,
    ReservationsDetailsComponent,
    QualificationDetailsComponent,
    AdditionalDetailsComponent,
    PhotoSignatureDetailsComponent,
    AdmissionDetailsComponent,
    DocumentDetailsComponent,
    StudentRegistrationTabComponent,
    StudentSettingComponent,
    StudentFormComponent,
    AdminSettingComponent,
    StudentRegisterComponent,
    StudentSettingPageComponent,
    StudentLoginComponent,
    AlertboxComponent,
    PdfviewerComponent,
    ConformationModelComponent,
    FeesComponent,
    FeeProcessComponent,
    PaymentHistoryComponent,
    ExamFormComponent,
    ExamFeesComponent,
    ExamFeeProcessComponent,
    ReceiptComponent,
    AdmitCardComponent,
    ReportsComponent,
    MarklistComponent,
    OpenCollegeAddmissionComponent,
    PaymentReceiptComponent,
    DownloadDetailsComponent,
    SubjectSelectionComponent,
    ExamEligibilityComponent,
    PrintMsgBoxComponent,
    ComplaintFormComponent,
    TCLCMCComponent,
    ComplaintComponent,
    TclcFeesComponent,
    TclcFeesProcessComponent,
    GrievanceCommentComponent,
    GrievanceCommentFormComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    CertificateComponent,
    TranscriptFeesComponent,
    TranscriptFeeProcessComponent,
    TranscriptComponent,
    EasebuzzPayComponent,
    RazorpayPayComponent,
    PayGatewayComponent,
    PaymentMessageComponent,
    ProvisionalComponent,
    CertificateLoginComponent,
    PracticalTimeTableComponent,
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTreeModule,
    A11yModule,
    NgxSpinnerModule,
    CdkAccordionModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    MatSelectFilterModule,
    ScrollingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: DateAdapter, useClass: DateFormat },
      { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }, // Global format
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptorService,
      multi: true
    },
    ModalpopService,DatePipe,
  ],
  bootstrap: [AppComponent,ConformationModelComponent],
})
export class AppModule { 
  constructor(private dateAdapter: DateAdapter<Date>) {
    dateAdapter.setLocale("en-in"); // DD/MM/YYYY
  }
}
